// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.field-qty[data-v-7db0ff18] {\n  max-width: 180px;\n}\n.qty-col[data-v-7db0ff18] {\n  min-width: 120px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
